import UserListItem from './UserListItem.component';

export default UserListItem;
